import React from 'react';
import styles from './Button.module.css';

const VARIANT_CLASSES = {
  primary: styles.primary,
  secondary: styles.secondary,
  ghost: styles.ghost,
  danger: styles.danger
};

const SIZE_CLASSES = {
  sm: styles.sizeSm,
  md: styles.sizeMd,
  lg: styles.sizeLg
};

export default function Button({
  variant = 'primary',
  size = 'md',
  iconLeft,
  iconRight,
  loading,
  disabled,
  className = '',
  children,
  ...rest
}) {
  const classNames = [
    styles.button,
    VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary,
    SIZE_CLASSES[size] || SIZE_CLASSES.md,
    loading ? styles.loading : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classNames} disabled={disabled || loading} {...rest}>
      {iconLeft ? <span className={styles.iconLeft}>{iconLeft}</span> : null}
      <span className={styles.label}>{children}</span>
      {iconRight ? <span className={styles.iconRight}>{iconRight}</span> : null}
    </button>
  );
}
